import { render, staticRenderFns } from "./LinkManage.vue?vue&type=template&id=789ad78b&"
import script from "./LinkManage.vue?vue&type=script&lang=ts&"
export * from "./LinkManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports